import styled from "styled-components";

interface StyledHeartIconProps {
  favorites?: boolean;
}

export const StyledHeartIcon = styled.button<StyledHeartIconProps>`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  opacity: 0.9;

  svg {
    display: block;
    max-height: 18px;

    ${({ favorites }) =>
      favorites &&
      `
      max-height: 32px;
    `}
  }

  &:hover {
    opacity: 1;
  }
`;
